import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SwiperOptions} from 'swiper/types';
import {Autoplay, Pagination} from 'swiper/modules';
import {TranslatePipe} from '@ngx-translate/core';
import {SwiperDirective} from "../../../../shared/directives/swiper/swiper.directive";
import {AdsService} from '../../../../shared/services/ads/ads.service';

@Component({
  selector: 'app-ad-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe, SwiperDirective],
  templateUrl: './ad-banner.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ['./ad-banner.css'],
})
export class AdBannerComponent implements OnInit {
  #adsService = inject(AdsService);

  ads = this.#adsService.ads;
  loading = this.#adsService.isLoading;

  config: WritableSignal<SwiperOptions> = signal<SwiperOptions>({
    modules: [Autoplay, Pagination],
    slidesPerView: 1,
    pagination: {
      el: '.ad-pagination',
      bulletClass: 'ad-pagination-bullet',
      clickable: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
  });

  ngOnInit(): void {
    this.#adsService.getAds().subscribe();
  }
}

